module.exports = __webpack_public_path__ + "static/media/twitter.21184f29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/twitter.svg
// module id = 906
// module chunks = 0